<div class="row">
    <div class="col-md-7">
        <h2>Pickup Calendar</h2>
    </div>
</div>
<div>
    <mt-search-filter-select [items]="pickupStatusMetaItems" entity="Status" (selectionChanged)="fetchEvents()"> </mt-search-filter-select>

    <mt-search-filter-select [items]="customerMetaItems" entity="Customer" (selectionChanged)="fetchEvents()"> </mt-search-filter-select>

    <mt-search-filter-select [items]="carrierMetaItems" entity="Carrier" (selectionChanged)="fetchEvents()"> </mt-search-filter-select>

    <mt-search-filter-select [items]="warehouseMetaItems" entity="Warehouse" (selectionChanged)="fetchEvents()"> </mt-search-filter-select>
</div>

<br />

<div class="row">
    <div class="col-md-12">
        <div class="miles-card padded">
            <br />
            <full-calendar [options]="calendarOptions"></full-calendar>
        </div>
    </div>
</div>

<mt-modal-wrapper [showActions]="false" [autoShow]="false" (ready)="pickupCalendarTableDialogApi = $event" [options]="modalOptions">
    <pickup-calendar-table-dialog *ngIf="selectedPickups?.length" [pickups]="selectedPickups" (onClose)="closePickupCalendarDialog()">
    </pickup-calendar-table-dialog>
</mt-modal-wrapper>
